export const DEFAULT_OPERATIONS = ["describe", "changes", "read", "query"];
